module.exports = __webpack_public_path__ + "static/4-325402e275ab5f9980f26dd48021fc31.png";